module.exports = __webpack_public_path__ + "img/drop-arrow.6c5a6deb.svg";